module.exports = __webpack_public_path__ + "static/media/service_tile_nordic.e4e03497.jpg";